// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c08f410f","605":"4b46379e","809":"62452d41","981":"f798ab5b"}[chunkId] + ".chunk.js";
};